import { convertToSlug } from "../../services/utils";
import "./index.scss";

const FampeInputRange = ({
  label = "",
  id = convertToSlug(label) || "customRange",
  name,
  value = 0,
  setValue,
  min = 0,
  max = 100,
  onBlur,
  isDisabled = false,
  legacyStyle = true,
  isCustomInpRange = true,
  themeColor = "",
}) => {
  const styleLabel = (value) => {
    value = parseInt(value);
    let css = {
      left: `${value}%`,
      transform: "translateX(0)",
    };
    if (value >= 2 && value <= 9) {
      css.transform = "translateX(-3px)";
    }
    if (value >= 10 && value <= 49) {
      css.transform = "translateX(-6px)";
    }
    if (value >= 50 && value <= 79) {
      css.transform = "translateX(-11px)";
    }
    if (value >= 80 && value <= 99) {
      css.transform = "translateX(-17px)";
    }
    if (value === 100) {
      css.transform = "translateX(-22px)";
    }

    return css;
  };

  return (
    <div
      className={
        "fampe-input-range" +
        (value > min ? " has-value" : "") +
        (!legacyStyle ? " new-style" : "") +
        (isCustomInpRange ? " wbs" : "")
      }
    >
      <div className={"input-range" + (isCustomInpRange ? " wbs" : "")}>
        <label htmlFor={id} className="form-label">
          {label}
        </label>
        <div className="input-range__wrapper-input">
          <div className="range-marker" style={{ left: "79%" }}>
            <span>
              80%
              <br />
              (limite padrão)
            </span>
          </div>

          <span className="label-value" style={styleLabel(value)}>
            {Math.round(value)}%
          </span>
          <div className="wrapper-line-input">
            <input
              type="range"
              data-value={value}
              name={name}
              value={value}
              onChange={(e) => setValue(e.target.value)}
              onBlur={onBlur}
              disabled={isDisabled}
              min={min}
              max={max}
              id={id}
            />
            <div
              className={"percent-bar " + themeColor}
              style={{ width: `${value}%` }}
            ></div>
          </div>
          <small>{min}%</small>
          {!legacyStyle ? (
            <small>
              <strong>{max}%</strong>
            </small>
          ) : (
            <small>{max}%</small>
          )}
        </div>
      </div>
    </div>
  );
};

export default FampeInputRange;
